import { Folder, type LucideIcon } from "lucide-react";
import {
    MAP_ICON_TO_LUCIDE_ICON,
    MAP_COLOR_TO_TEXT_CLASS_NAME,
    MAP_COLOR_TO_BG_CLASS_NAME,
} from "../consts";

// // // //

export interface CatalogIconStyles {
    Icon: LucideIcon;
    iconClassName: string;
    bgClassName: string;
}

/**
 * Resolves the `icon` + `color` stored on a catalog item (Measure,
 * ReferenceData, or a FilterMetadata category) into its Lucide icon and
 * Tailwind classnames, falling back to a neutral folder badge for values that
 * aren't in the maps.
 *
 * Prefer the CatalogIcon component when you just need the tinted badge - reach
 * for this directly only when you need the parts (e.g. to build classnames for
 * a non-React consumer).
 */
export function getCatalogIconStyles(props: {
    icon?: string | null;
    color?: string | null;
}): CatalogIconStyles {
    const { icon, color } = props;

    return {
        Icon:
            MAP_ICON_TO_LUCIDE_ICON[
                icon as keyof typeof MAP_ICON_TO_LUCIDE_ICON
            ] ?? Folder,
        iconClassName:
            MAP_COLOR_TO_TEXT_CLASS_NAME[
                color as keyof typeof MAP_COLOR_TO_TEXT_CLASS_NAME
            ] ?? "text-muted-foreground",
        bgClassName:
            MAP_COLOR_TO_BG_CLASS_NAME[
                color as keyof typeof MAP_COLOR_TO_BG_CLASS_NAME
            ] ?? "bg-muted",
    };
}
